import React from 'react';
import SummaryItem from '../SummaryItem';

// Utils
import { questionsVisibility } from '@utils/miscellaneous/pageAndQuestionsVisibility';
import { useSelector } from 'react-redux';
import { selectIfShowFullTimeStudentEnabled } from '@reducers/appReducer';

const FullTimeStudentInfo = props => {

    const {
        applyingForCoverageIndicator,
        dateOfBirth,
        idx,
        fullTimeStudent,
        serverDate
    } = props;

    const showFullTimeStudentEnabled = useSelector(selectIfShowFullTimeStudentEnabled);

    const isFullTimeStudent = questionsVisibility.isFullTimeStudentShown({
        applyingForCoverageIndicator,
        dateOfBirth,
        serverDate,
        showFullTimeStudentEnabled
    });

    if (!isFullTimeStudent) {
        return null;
    }

    return (
        <SummaryItem
            textCode = 'common.full_time_student'
            value = { fullTimeStudent }
            noPriorDataValues = { [ null ] }
            desc = {
                [
                    [
                        `taxHousehold.householdMember[${ idx }].fullTimeStudent`
                    ]
                ]
            }
        />
    );
};

export default FullTimeStudentInfo;